/**
 * 人事システムや Excel から出力した CSV は Shift_JIS のことがあるため、
 * UTF-8 として読めない場合は Shift_JIS で読み直す。
 */
export async function readCsvFile(file: File): Promise<string> {
  const buffer = await file.arrayBuffer()
  try {
    return new TextDecoder('utf-8', { fatal: true }).decode(buffer)
  } catch {
    return new TextDecoder('shift_jis').decode(buffer)
  }
}
